import config from '@/assets/js/config.js'

//全局改变state参数
function modifyValue (state, {
  variable,
  value
}) {
  state[variable] = value
}

//全局改变router
function getRouter (state, res) {
  if (res.data.industry_id == 1 || res.data.industry.select_dir_id != 0) {
    const data = {
      color: '#7A7E83',
      selectedColor: '#00a0ff',
      list: [
        {
          pagePath: '/homeCatalog?',
          iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab11.png',
          selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab1.png',
          icon: 'icon-061',
          text: '首页',
        },
        {
          pagePath: '/homeCatalog/morePaeg?',
          iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab44.png',
          selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab4.png',
          icon: 'icon-quanping',
          text: res.data.industry.select_dir_id != 0 ? res.data.industry.select_dir_info.name : '精美图库',
        },
        {
          pagePath: '/searchCatalog/index?',
          iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab22.png',
          selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab2.png',
          icon: 'icon-062',
          text: '搜索',
        },
        {
          pagePath: '/contactCatalog/index?',
          iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab44.png',
          selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab4.png',
          icon: 'icon-063',
          text: '联系',
        },
      ],
    }
    state.data = data
  }
  if(res.data.is_open_effect == 1 && !state.data.list.some(i=>i.text == '工具')){
    let data = JSON.parse(JSON.stringify(state.data))
    data.list.splice(2,0,{
      pagePath: '/classifyCatalog?',
      iconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab11.png',
      selectedIconPath: 'https://near.us-msc.com/data/xcx_pic/index/tab1.png',
      icon: 'icon-057',
      text: '工具',
    })
    state.data = data
  }
}

//全局微信分享
function onMenuShare (state, res) {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    typeof WeixinJSBridge !== 'undefined' && WeixinJSBridge.call('showOptionMenu')
    config.methods.wx_config([
      'checkJsApi',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'chooseWXPay',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'uploadImage',
      'previewImage',
      'chooseImage',
      'downloadImage',
      'getLocalImgData',
    ]).then((wx) => {
      const shareData = {
        title: res.data.name, // 分享标题
        desc: res.data.share_desc,
        link: `${document.location.href.split('?')[0]}?alias=${state.loginInfo.album_alias}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: res.data.cover_image_text, // 分享图标
      }
      wx.updateAppMessageShareData(shareData)
      wx.onMenuShareAppMessage(shareData)
      wx.updateTimelineShareData(shareData)
      wx.onMenuShareTimeline(shareData)
    })
  }
}
export default {
  modifyValue,
  getRouter,
  onMenuShare
}
